export const getEnumValues = <TEnum extends object = object>(enumDefinition: TEnum) => {
    const values = Object.values(enumDefinition);
    const result: Array<{
        enum: keyof TEnum;
        value: TEnum[keyof TEnum];
    }> = [];

    if (values.every(v => typeof v === "string")) {
        const keys = Object.keys(enumDefinition);
        for (let index = 0; index < keys.length && index < values.length; index++) {
            result.push({
                enum: keys[index] as keyof TEnum,
                value: values[index] as TEnum[keyof TEnum],
            });
        }
    } else {
        const halfSize = values.length / 2;
        for (let index = 0; index < halfSize; index++) {
            result.push({
                enum: values[index] as keyof TEnum,
                value: values[halfSize + index] as TEnum[keyof TEnum],
            });
        }
    }

    return result;
};